
const initialState = {
  fetching: false,
  fetched: false,
  receivedAt: null,
  data: {}
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'TOKEN_INFLIGHT':
      return Object.assign({}, state, { error: null, fetching: true, fetched: false });
    case 'TOKEN_FAILED':
      state = Object.assign({}, state, {
        fetching: false,
        fetched: true,
        receivedAt: action.receivedAt,
        error: action.error
      });
      break;
    case 'TOKEN_SUCCESS':
      state = Object.assign({}, state, {
        fetching: false,
        fetched: true,
        receivedAt: action.receivedAt,
        data: action.data
      });
      break;
    case 'LOGOUT_USER':
      return initialState;
  }
  return state;
}
